import React from 'react';

import { Document } from '../../shared/icons';
import { ConfirmationModal } from '../../shared/modal/ConfirmationModal';
import { ModalHeader } from '../../shared/modal/ModalHeader';
import styles from './Documents.module.scss';

interface DisabledDocumentModalProps {
    isOpen: boolean;
    closeModal: () => void;
}

export const DisabledDocumentModal: React.FC<DisabledDocumentModalProps> = ({ isOpen, closeModal }) => (
    <ConfirmationModal
        isOpen={isOpen}
        closeModal={closeModal}
        closeLabel='Close'
        showConfirm={false}
    >
        <ModalHeader icon={Document} label='Document Permission Required' />
        <div className={styles.documentRenameWrapper}>
           Your Access Group(s) do not currently have the permission to view this document type. Please speak to your administrator to resolve this, or if this was uploaded in error you have the option to delete it.
        </div>
    </ConfirmationModal>
);
